import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-645ddc20"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "view w-100 h-100" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line dark-blue" }, null, -1))
const _hoisted_4 = { class: "circle-border dark-blue" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line dark-blue" }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line blue" }, null, -1))
const _hoisted_7 = { class: "circle-border blue" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line blue" }, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line orange" }, null, -1))
const _hoisted_10 = { class: "circle-border orange" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line orange" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_view_header = _resolveComponent("view-header")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_view_header, {
      text: _ctx.t('cashier.main-menu.header')
    }, null, 8, ["text"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass(["d-flex justify-content-center align-items-center", [_ctx.mainMenuSelect === 1 ? '' : 'hide-hover']])
      }, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_router_link, {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.selectMenuItem(1))),
            class: "btn-round btn-dark-blue",
            to: { name: 'select-price-type' }
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("cashier.label.neworder").toUpperCase()), 1)
            ]),
            _: 1
          })
        ]),
        _hoisted_5
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(["d-flex justify-content-center align-items-center", [_ctx.mainMenuSelect === 2 ? '' : 'hide-hover']])
      }, [
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_router_link, {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectMenuItem(2))),
            class: "btn-round btn-blue",
            to: { name: 'order-seach' }
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("cashier.label.reservedorder").toUpperCase()), 1)
            ]),
            _: 1
          })
        ]),
        _hoisted_8
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(["d-flex justify-content-center align-items-center", [_ctx.mainMenuSelect === 3 ? '' : 'hide-hover']])
      }, [
        _hoisted_9,
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_router_link, {
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectMenuItem(3))),
            class: "btn-round btn-orange",
            to: { name: 'club-voucherList' }
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('cashier.label.clubs-vouchers').toUpperCase()), 1)
            ]),
            _: 1
          })
        ]),
        _hoisted_11
      ], 2)
    ])
  ]))
}